// ABOUTME: Defines bounded request payloads for metadata-driven list searches.
// ABOUTME: Separates list data needs from dashboard aggregation response fields.
export const getListSearchParams = (
    companyId: number,
    filters: Compleo.IObject,
    overrides: Compleo.IObject = {}
) => ({
    companyId,
    ...filters,
    ...overrides,
    returnAggregationsAfterQuery: false
});

export const getListTotalParams = (
    companyId: number,
    otherGenericParams?: Compleo.IObject
) => ({
    companyId,
    returnTotal: true,
    returnAggs: false,
    fieldsToReturn: ["pk"],
    pagination: { pageSize: 1, currentPage: 1 },
    otherGenericParams
});
